var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconFininvest = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlSpace: "preserve",
  id: "Layer_1",
  x: 0,
  y: 0,
  style: {
    enableBackground: "new 0 0 259.1 159.2"
  },
  viewBox: "0 0 259.1 159.2",
  ref: svgRef
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#2d2729}.st1{fill:none;stroke:#fff;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.st2{fill:#fff}.st3{stroke-width:2;stroke-linecap:round;stroke-linejoin:round}.st3,.st4,.st5{fill:none;stroke:#000}.st4{stroke-width:1.5;stroke-miterlimit:10}.st5{stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:7.5407,7.5407}.st6{fill:#191a1a}.st7{fill:#9d9d9d}.st10,.st11,.st12{stroke-miterlimit:10}.st10{stroke:#000;stroke-width:1.5}.st11,.st12{fill:none;stroke:#070707}.st12{stroke:#000;stroke-width:2}.st13,.st14{fill-rule:evenodd;clip-rule:evenodd;fill:#0f0f08}.st14{fill:#fff}")), /*#__PURE__*/React.createElement("path", {
  d: "M33.9 144.4H227c2.8 0 5.1-2.3 5.1-5.1V12.9c0-2.8-2.3-5.1-5.1-5.1H33.9c-2.8 0-5.1 2.3-5.1 5.1v126.5c0 2.8 2.3 5 5.1 5z",
  style: {
    stroke: "#000",
    strokeMiterlimit: 10
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.8 95.2h203.3v22.7H28.8z",
  style: {
    fill: "#f4f4f4"
  }
}));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconFininvest, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/IconFininvest.3f61db19.svg";
export { ForwardRef as ReactComponent };